// application.js
import "@hotwired/turbo-rails"
import Rails from "@rails/ujs"
import * as bootstrap from "bootstrap";
import "./controllers";
import "./bulk_route";
import "./orders_manual_sent";
import "./sidebar";
import "./offcanvas_forms";
import { initAddressLocationFilter } from "./address_location_filter";
import { initProfileFeatureSearch } from "./profile_feature_search";
import { initDashboardLayout } from "./dashboard_layout";
import { initOccurrenceReasonsOrder } from "./occurrence_reasons_order";
import $ from "jquery"
import moment from "moment";
import "bootstrap-daterangepicker"
import Inputmask from "inputmask"

Rails.start()

window.$ = $
window.jQuery = $
window.moment = moment
window.bootstrap = bootstrap

$(function () {
  $('#daterange').daterangepicker({
    locale: {
      format: 'DD/MM/YYYY'
    }
  })
})

import { initMap, wireRoutesButton } from "./leaflet_map";

// Sem Turbo: use DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  console.log("app DOMContentLoaded"); // debug
  initAddressLocationFilter();
  initMap();
  wireRoutesButton(); // liga o botão Rotas ao fetch + offcanvas
  initProfileFeatureSearch();
  initDashboardLayout();
  initOccurrenceReasonsOrder();
});

// Toastr (mantém como já estava)
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".toast").forEach((toastEl) => {
    const toast = new bootstrap.Toast(toastEl, { delay: 4000 });
    toast.show();
  });
});

document.addEventListener("turbo:load", () => {
  initProfileFeatureSearch();
  initDashboardLayout();
  initOccurrenceReasonsOrder();
});

function initSessionTimeout() {
  const timeoutTag = document.querySelector('meta[name="session-timeout"]');
  const refreshUrlTag = document.querySelector('meta[name="session-refresh-url"]');
  const csrfTokenTag = document.querySelector('meta[name="csrf-token"]');
  const modalEl = document.getElementById("modal-timeout");
  const timeoutSeconds = Number.parseInt(timeoutTag?.content || "", 10);

  if (!timeoutTag || !modalEl || !Number.isFinite(timeoutSeconds) || timeoutSeconds <= 0) return;
  if (window.__sessionTimeoutInitialized) return;

  window.__sessionTimeoutInitialized = true;

  const sessionTimeout = timeoutSeconds * 1000;
  const refreshInterval = Math.min(Math.max(sessionTimeout / 2, 5000), 60000);
  let idleTimer;
  let lastSessionRefresh = 0;

  function showSessionExpiredModal() {
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, {
      backdrop: "static",
      keyboard: false
    });

    modal.show();
  }

  function refreshSession() {
    const refreshUrl = refreshUrlTag?.content;
    const csrfToken = csrfTokenTag?.content;
    const now = Date.now();

    if (!refreshUrl || !csrfToken || now - lastSessionRefresh < refreshInterval) return;

    lastSessionRefresh = now;

    fetch(refreshUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest"
      }
    }).catch(() => {});
  }

  function resetIdleTimer() {
    if (modalEl.classList.contains("show")) return;

    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(showSessionExpiredModal, sessionTimeout);
    refreshSession();
  }

  ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach((eventName) => {
    document.addEventListener(eventName, resetIdleTimer, { passive: true });
  });

  resetIdleTimer();
}

document.addEventListener("DOMContentLoaded", initSessionTimeout);
document.addEventListener("turbo:load", initSessionTimeout);
